module.exports = __webpack_public_path__ + "media/20.ee26443b.mp3";